import { render, staticRenderFns } from "./prepayment.vue?vue&type=template&id=573ae6f6&scoped=true&"
import script from "./prepayment.vue?vue&type=script&lang=ts&"
export * from "./prepayment.vue?vue&type=script&lang=ts&"
import style0 from "./prepayment.vue?vue&type=style&index=0&id=573ae6f6&lang=less&scoped=true&"
import style1 from "./prepayment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ae6f6",
  null
  
)

component.options.__file = "prepayment.vue"
export default component.exports